import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import logo from '../assets/swise_black.png';
import check from '../assets/check_ok.png'
import LeftSide from '../components/LeftSide'
import { useTranslation } from 'react-i18next';

const SignupMessage = () => {
  const navigate = useNavigate();
  const signupmessageCardRef = useRef<HTMLDivElement>(null);
  const [signupmessageHeight, setLoginHeight] = useState<number | undefined>(undefined);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const storedLang = localStorage.getItem('language') || 'EN';
    i18n.changeLanguage(storedLang);
  }, []);

  useEffect(() => {
    if (!signupmessageCardRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setLoginHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(signupmessageCardRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  const handleSubmit = () => {

      navigate('/');

  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Left Side */}
      <Box
        sx={{
          width: '60%',
          bgcolor: 'black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LeftSide minHeight={signupmessageHeight} />
      </Box>

      {/* Right Side */}
      <Box
        sx={{
          width: '40%',
          bgcolor: 'black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          ref={signupmessageCardRef}
          sx={{
            width: '80%',
            bgcolor: 'white',
            borderRadius: 2,
            p: 4,
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <img
            src={logo}
            alt="Swise Logo"
            style={{
              width: '100px',
              height: 'auto',
              marginBottom: '56px',
              alignSelf: 'flex-start',
            }}
          />

          {/* Text centered */}
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <img
              src={check}
              alt="Success Check"
              style={{
                width: '60px',
                height: '60px',
                marginBottom: '30px',
              }}
            />
            <Typography
              gutterBottom
              sx={{
                fontWeight: 'bold',
                fontSize: '25px',
                color: '#73AF73',
                mb: 3,
              }}
            >
              {t('thanksRequest')}
            </Typography>
            <Typography
              gutterBottom
              sx={{
                fontWeight: 'bold',
                fontSize: '20px',
                color: 'black',
                mb: 1,
              }}
            >
              {t('sentEmailConfirmation')}
            </Typography>
            <Typography
              sx={{
                alignSelf: 'center',
                fontSize: '14px',
                color: 'black',
                mb: 4
              }}
            >
              {t('checkJunkFolder')}
            </Typography>
            <Button
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                sx={{
                  mt: 2,
                  height: '45px', // 56px == standard
                  backgroundColor: '#73AF73',
                  mb: 17,
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: '#A8CFA9',
                  },
                }}
              >
                {t('login')}
            </Button>
          </Box>
          <Typography
            sx={{
              fontSize: '15px',
              color: 'grey',
              mt: 3,
              alignSelf: 'flex-start',
            }}
          >
            © 2025 Swise AG
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SignupMessage;